export * from "./types";
export * from "./functions";
import * as queries from "./queries";

const ThreeSpeakIntegration = {
  queries,
};

export { ThreeSpeakIntegration };
